/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FundDto } from '../../models/fund-dto';

export interface GetAllByManagementCompanyId$Params {
  managementCompanyId: string;
}

export function getAllByManagementCompanyId(http: HttpClient, rootUrl: string, params: GetAllByManagementCompanyId$Params, context?: HttpContext): Observable<StrictHttpResponse<FundDto>> {
  const rb = new RequestBuilder(rootUrl, getAllByManagementCompanyId.PATH, 'get');
  if (params) {
    rb.path('managementCompanyId', params.managementCompanyId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FundDto>;
    })
  );
}

getAllByManagementCompanyId.PATH = '/management-companies/{managementCompanyId}/funds';
